export default {"src":"/_next/static/media/doctor.ab02f7ad.svg","height":389,"width":514,"blurWidth":0,"blurHeight":0};